import ListManagement from './views/List.vue'
import CreateEditManagement from './views/CreateEdit.vue'
import GetManagement from './views/Get.vue'

export const ManagementRoutes = [
  {
    path: '/managements',
    name: 'ListManagements',
    component: ListManagement,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'management:list'
    }
  },
  {
    path: '/management',
    name: 'CreateManagement',
    component: CreateEditManagement,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'management:create'
    }
  },
  {
    path: '/management/:id',
    name: 'UpdateManagement',
    component: CreateEditManagement,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'management:update'
    }
  },
  {
    path: '/management/view/:id',
    name: 'GetManagement',
    component: GetManagement,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'management:get'
    }
  }
]
